export var customEndpointFunctions = {};